var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"chart-wrapper"},[_c('div',{staticStyle:{"width":"100%","height":"450px"},attrs:{"id":"productComparison"}})])])
}]

export { render, staticRenderFns }